import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import HeaderBar from "../components/header/HeaderBar";

class SportaLoginContainer extends Component {
  UNSAFE_componentWillMount = () => {
    fetch("https://tournify-server.herokuapp.com/authenticateSportaUser", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        code: this.props.code,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (payload) {
          // console.log(payload);
          window.firebase
            .auth()
            .signInWithCustomToken(payload.jwt)
            .then(() => {
              this.props.history.push("/");
            })
            .catch(function (error) {
              // Handle Errors here.
              // var errorCode = error.code;
              var errorMessage = error.message;
              console.log("error", errorMessage);
              // ...
            });
        }.bind(this)
      );
  };

  render() {
    return (
      <div>
        <HeaderBar user={this.props.user} sporta={true} />
      </div>
    );
  }
}

export default withRouter(SportaLoginContainer);
